<div class="render-user-row">
  <tui-avatar
    [src]="getAvatarUrl() | tuiFallbackSrc: (user | userDisplayableName: 'short' | tuiInitials) | async"
    [style.background]="
      !getAvatarUrl() && (user | userDisplayableName: 'short')
        ? (user | userDisplayableName: 'short' | tuiAutoColor)
        : ('' | tuiAutoColor)
    "
    [size]="'m'"
    [round]="true"
  ></tui-avatar>

  <div class="render-user-row__info">
    <div class="render-user-row__title">
      <span class="render-user-row__text tui-text_body-m">{{ user.fullName }}</span>

      <ng-container *ngIf="statusContent">
        <ng-container *ngTemplateOutlet="statusContent; context: { $implicit: user }"></ng-container>
      </ng-container>
    </div>

    <ng-container *ngFor="let organisationJobTitle of user.jobTitlesInOrganisation">
      <span class="render-user-row__text tui-text_body-s" [style.color]="'var(--tui-text-tertiary)'">
        {{ organisationJobTitle | orgJobTitleDisplayableName }}
      </span>
    </ng-container>
  </div>
</div>
